/* unplugin-vue-components disabled */import { ElDialog as __unplugin_components_8 } from 'element-plus/es';import 'element-plus/es/components/dialog/style/css';
import { ElTable as __unplugin_components_7 } from 'element-plus/es';import 'element-plus/es/components/table/style/css';
import { ElButton as __unplugin_components_6 } from 'element-plus/es';import 'element-plus/es/components/button/style/css';
import { ElTableColumn as __unplugin_components_5 } from 'element-plus/es';import 'element-plus/es/components/table-column/style/css';
import { ElInput as __unplugin_components_4 } from 'element-plus/es';import 'element-plus/es/components/input/style/css';
import { ElSelect as __unplugin_components_3 } from 'element-plus/es';import 'element-plus/es/components/select/style/css';
import { ElOption as __unplugin_components_2 } from 'element-plus/es';import 'element-plus/es/components/option/style/css';
import { ElIcon as __unplugin_components_1 } from 'element-plus/es';import 'element-plus/es/components/icon/style/css';
import __unplugin_components_0 from '~icons/ep/info-filled';
import "core-js/modules/es.array.push.js";
import { defineComponent as _defineComponent } from 'vue';
import { unref as _unref, createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, normalizeClass as _normalizeClass, isRef as _isRef, createCommentVNode as _createCommentVNode, createBlock as _createBlock, createTextVNode as _createTextVNode, withModifiers as _withModifiers, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue";
const _withScopeId = n => (_pushScopeId("data-v-aae31324"), n = n(), _popScopeId(), n);
const _hoisted_1 = {
  class: "flex items-center"
};
const _hoisted_2 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, "遇到问题配置", -1));
const _hoisted_3 = {
  class: "container"
};
const _hoisted_4 = {
  class: "right"
};
const _hoisted_5 = ["onClick"];
const _hoisted_6 = {
  class: "label"
};
const _hoisted_7 = {
  key: 0,
  class: "item"
};
const _hoisted_8 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("div", {
  class: "label"
}, "绑定手机", -1));
const _hoisted_9 = {
  class: "left"
};
const _hoisted_10 = {
  key: 0
};
const _hoisted_11 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("span", {
  class: "marginL10"
}, "自动识别：", -1));
const _hoisted_12 = {
  key: 1,
  class: "account"
};
const _hoisted_13 = {
  class: "item"
};
const _hoisted_14 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("span", {
  class: "label"
}, "注销地址：", -1));
const _hoisted_15 = {
  class: "dialog-footer"
};
import USwitch from '@ultra/share/components/USwitch/index.vue';
import { apiUsdkUpdateAnnounceProduct, apiUsdkGetQuestionConfEdit } from '@/api/usdk';
import { useAppStore } from '@/store/modules/app';
// 初始化表单数据
export default /*#__PURE__*/_defineComponent({
  __name: 'helpCustomDialog',
  emits: ['success'],
  setup(__props, {
    expose: __expose,
    emit: __emit
  }) {
    const appStore = useAppStore();
    const currentSelect = ref();
    const emits = __emit;
    const dialogVisible = ref(false);
    const confirmLoading = ref(false);
    const type = ref('all');
    const formArr = ref([{
      label: '短信验证：',
      key: 'problemSmsVerify'
    },
    // { label: '账号问题：', key: 'problemAccount' },
    {
      label: '联系客服：',
      key: 'problemContactCs',
      url: {
        key: 'tel',
        placeholder: '请输入联系方式',
        label: '联系名称：'
      }
    }, {
      label: '账号注销：',
      key: 'accountCancel',
      url: {
        key: 'logoutUrl',
        placeholder: '请输入注销地址',
        label: '注销地址：'
      }
    }]);
    const isSwitchBindPhone = ref(0);
    const questionConf = ref([]);
    const multipleSelected = ref();
    const gameInfo = ref();
    const tableData = ref();
    const form = ref({
      env: 1,
      problemSmsVerify: 0,
      problemAccount: 0,
      problemPay: 0,
      problemContactCs: 0,
      accountCancel: 0,
      modifyRealName: 0,
      loginCsEntry: 0,
      payCsEntry: 0,
      tel: '',
      logoutUrl: ''
    });
    const currentPlat = ref('qq');
    const options = ref([{
      value: 'qq',
      label: 'QQ'
    }]);
    // const rules = reactive<FormRules>({
    // 	tel: { required: true, message: '请输入联系方式', trigger: 'blur' },
    // 	logoutUrl: { required: true, message: '请输入注销地址', trigger: 'blur' },
    // });
    const isShowBindPhone = computed(() => {
      return process.env.VUE_APP_PLAT === 'ml';
    });
    const handleClose = () => {
      dialogVisible.value = false;
      initFormData();
    };
    // 切换选择
    const handleSelect = item => {
      currentSelect.value = item.key;
    };
    const tableDataKeFu = ref([]);
    // 删除行
    const deleteRow = scope => {
      tableDataKeFu.value.splice(scope.$index, 1);
    };
    // 添加行
    const onAddItem = () => {
      tableDataKeFu.value.push({
        title: '',
        link: ''
      });
    };
    const isJudgeValue = data => {
      let flag = false;
      data.forEach(i => {
        if (!i.title) {
          flag = true;
        }
      });
      return flag;
    };
    const handleOk = () => {
      let flag = false;
      formArr.value.forEach(item => {
        if (item.url && form.value[item.key]) {
          if (item.url.key === 'logoutUrl' && !form.value[item.url.key]) {
            flag = true;
            return ElMessage.error('请输入注销地址');
          }
          if (item.url.key === 'tel' && tableDataKeFu.value.length === 0) {
            flag = true;
            return ElMessage.error('请配置联系名称或跳转链接');
          }
          if (item.url.key === 'tel' && tableDataKeFu.value.length > 0) {
            console.log('tableDataKeFu', tableDataKeFu.value);
            if (isJudgeValue(tableDataKeFu.value)) {
              flag = true;
              return ElMessage.error('请填写联系名称');
            }
          }
        }
      });
      if (flag) return;
      let params = JSON.parse(JSON.stringify(form.value));
      if (type.value === 'batchEdit') {
        params.productIds = multipleSelected.value.map(item => item.productId).join(',');
      } else if (type.value === 'all') {
        params.productIds = tableData.value.map(item => item.productId).join(',');
      } else {
        params.productIds = params.productId;
      }
      params.gid = gameInfo.value.Id;
      confirmLoading.value = true;
      apiUsdkUpdateAnnounceProduct(params).then(res => {
        if (res.code === 0) {
          emits('success');
          handleClose();
        }
      }).finally(() => {
        confirmLoading.value = false;
      });
      let surfix = '';
      questionConf.value.map(i => {
        if (i.var === 'lc.un_bind_wechat_tip') {
          i.val = form.value.tel;
          surfix = i.surfix;
        }
        if (i.var === 'lc.sdk.config.logoutUrl') {
          i.val = form.value.logoutUrl;
        }
        if (i.var === 'lc.un_bind_customer') {
          i.val = JSON.stringify(tableDataKeFu.value);
        }
        if (i.var === 'login.bind.phone.enable') {
          i.val = isSwitchBindPhone.value ? '1' : '0';
        }
      });
      questionConf.value.push({
        val: form.value.tel,
        var: 'lc.un_bind_tel_tip',
        surfix: surfix,
        caption: '',
        id: ''
      });
      handleQuestionConfEdit(params.productIds, JSON.stringify(questionConf.value));
    };
    const handleQuestionConfEdit = async (productId, data) => {
      await apiUsdkGetQuestionConfEdit({
        productId,
        data
      });
    };
    const show = payload => {
      dialogVisible.value = true;
      gameInfo.value = payload.gameInfo;
      type.value = payload.type;
      if (payload.type === 'all') {
        tableData.value = payload.tableData;
      } else if (payload.type === 'batchEdit') {
        multipleSelected.value = payload.multipleSelected;
      } else {
        questionConf.value = payload.questionConf;
        form.value = payload.data;
        formatData(payload.questionConf);
        console.log('questionConf', questionConf.value);
        questionConf.value.forEach(item => {
          if (item.var === 'login.bind.phone.enable') {
            isSwitchBindPhone.value = item.val === '1' ? 1 : 0;
            console.log('isSwitchBindPhone', isSwitchBindPhone.value);
          }
        });
      }
    };
    // 格式化数据
    const formatData = data => {
      data.map(i => {
        if (i.var === 'lc.un_bind_customer' && i.val) {
          tableDataKeFu.value = JSON.parse(i.val);
        }
      });
    };
    const initFormData = () => {
      form.value = {
        env: 1,
        problemSmsVerify: 0,
        problemAccount: 0,
        problemPay: 0,
        problemContactCs: 0,
        accountCancel: 0,
        modifyRealName: 0,
        loginCsEntry: 0,
        payCsEntry: 0,
        tel: '',
        logoutUrl: ''
      };
    };
    const handleToQustion = () => {
      dialogVisible.value = false;
      appStore.isOpenComment = true;
    };
    // 处理复制的qq 链接
    const handleInputLink = (e, row) => {
      try {
        const tempElement = document.createElement('div');
        tempElement.innerHTML = e;
        const linkElement = tempElement.querySelector('a');
        const hrefValue = linkElement.href;
        row.link = hrefValue;
      } catch (error) {
        row.link = e;
      }
    };
    __expose({
      show
    });
    return (_ctx, _cache) => {
      const _component_i_ep_info_filled = __unplugin_components_0;
      const _component_el_icon = __unplugin_components_1;
      const _component_el_option = __unplugin_components_2;
      const _component_el_select = __unplugin_components_3;
      const _component_el_input = __unplugin_components_4;
      const _component_el_table_column = __unplugin_components_5;
      const _component_el_button = __unplugin_components_6;
      const _component_el_table = __unplugin_components_7;
      const _component_el_dialog = __unplugin_components_8;
      return _openBlock(), _createBlock(_component_el_dialog, {
        modelValue: _unref(dialogVisible),
        "onUpdate:modelValue": _cache[5] || (_cache[5] = $event => _isRef(dialogVisible) ? dialogVisible.value = $event : null),
        width: "800px",
        "before-close": () => handleClose()
      }, {
        header: _withCtx(() => [_createElementVNode("div", _hoisted_1, [_hoisted_2, _createVNode(_component_el_icon, {
          class: "marginL10 question",
          size: 16,
          color: "#FEC171",
          onClick: handleToQustion
        }, {
          default: _withCtx(() => [_createVNode(_component_i_ep_info_filled)]),
          _: 1
        })])]),
        footer: _withCtx(() => [_createElementVNode("span", _hoisted_15, [_createVNode(_component_el_button, {
          onClick: _cache[3] || (_cache[3] = $event => handleClose())
        }, {
          default: _withCtx(() => [_createTextVNode("取消")]),
          _: 1
        }), _createVNode(_component_el_button, {
          type: "primary",
          onClick: _cache[4] || (_cache[4] = $event => handleOk())
        }, {
          default: _withCtx(() => [_createTextVNode("确定")]),
          _: 1
        })])]),
        default: _withCtx(() => {
          var _unref$find, _unref$find3;
          return [_createElementVNode("div", _hoisted_3, [_createElementVNode("div", _hoisted_4, [(_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(formArr), (item, index) => {
            return _openBlock(), _createElementBlock("div", {
              class: _normalizeClass(['item', _unref(currentSelect) === item.key ? 'active' : '']),
              key: index,
              onClick: $event => handleSelect(item)
            }, [_createElementVNode("div", _hoisted_6, _toDisplayString(item.label), 1), _createVNode(USwitch, {
              modelValue: _unref(form)[item.key],
              "onUpdate:modelValue": $event => _unref(form)[item.key] = $event
            }, null, 8, ["modelValue", "onUpdate:modelValue"])], 10, _hoisted_5);
          }), 128)), _unref(isShowBindPhone) ? (_openBlock(), _createElementBlock("div", _hoisted_7, [_hoisted_8, _createVNode(USwitch, {
            modelValue: _unref(isSwitchBindPhone),
            "onUpdate:modelValue": _cache[0] || (_cache[0] = $event => _isRef(isSwitchBindPhone) ? isSwitchBindPhone.value = $event : null)
          }, null, 8, ["modelValue"])])) : _createCommentVNode("", true)]), _createElementVNode("div", _hoisted_9, [_unref(currentSelect) === 'problemContactCs' ? (_openBlock(), _createElementBlock("div", _hoisted_10, [_hoisted_11, _createVNode(_component_el_select, {
            modelValue: _unref(currentPlat),
            "onUpdate:modelValue": _cache[1] || (_cache[1] = $event => _isRef(currentPlat) ? currentPlat.value = $event : null),
            placeholder: "Select"
          }, {
            default: _withCtx(() => [(_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(options), item => {
              return _openBlock(), _createBlock(_component_el_option, {
                key: item.value,
                label: item.label,
                value: item.value
              }, null, 8, ["label", "value"]);
            }), 128))]),
            _: 1
          }, 8, ["modelValue"]), _createVNode(_component_el_table, {
            data: _unref(tableDataKeFu),
            style: {
              "width": "100%"
            },
            "max-height": "250"
          }, {
            default: _withCtx(() => [_createVNode(_component_el_table_column, {
              prop: "title",
              label: "联系名称"
            }, {
              default: _withCtx(scope => [_createVNode(_component_el_input, {
                modelValue: scope.row.title,
                "onUpdate:modelValue": $event => scope.row.title = $event,
                placeholder: "请输入联系名称"
              }, null, 8, ["modelValue", "onUpdate:modelValue"])]),
              _: 1
            }), _createVNode(_component_el_table_column, {
              prop: "link",
              label: "跳转链接（选填）"
            }, {
              default: _withCtx(scope => [_createVNode(_component_el_input, {
                modelValue: scope.row.link,
                "onUpdate:modelValue": $event => scope.row.link = $event,
                placeholder: "请输入跳转链接",
                onChange: e => handleInputLink(e, scope.row)
              }, null, 8, ["modelValue", "onUpdate:modelValue", "onChange"])]),
              _: 1
            }), _createVNode(_component_el_table_column, {
              label: "操作",
              width: "100"
            }, {
              default: _withCtx(scope => [_createVNode(_component_el_button, {
                link: "",
                type: "danger",
                size: "small",
                onClick: _withModifiers($event => deleteRow(scope), ["prevent"])
              }, {
                default: _withCtx(() => [_createTextVNode(" 删除 ")]),
                _: 2
              }, 1032, ["onClick"])]),
              _: 1
            })]),
            _: 1
          }, 8, ["data"]), _createVNode(_component_el_button, {
            style: {
              "width": "100%",
              "margin-top": "20px"
            },
            onClick: onAddItem
          }, {
            default: _withCtx(() => [_createTextVNode("添加")]),
            _: 1
          })])) : _createCommentVNode("", true), _unref(currentSelect) === 'accountCancel' ? (_openBlock(), _createElementBlock("div", _hoisted_12, [_createElementVNode("div", _hoisted_13, [_hoisted_14, _createVNode(_component_el_input, {
            modelValue: _unref(form)[(_unref$find = _unref(formArr).find(i => i.key === 'accountCancel')) === null || _unref$find === void 0 ? void 0 : _unref$find.url.key],
            "onUpdate:modelValue": _cache[2] || (_cache[2] = $event => {
              var _unref$find2;
              return _unref(form)[(_unref$find2 = _unref(formArr).find(i => i.key === 'accountCancel')) === null || _unref$find2 === void 0 ? void 0 : _unref$find2.url.key] = $event;
            }),
            placeholder: (_unref$find3 = _unref(formArr).find(i => i.key === 'accountCancel')) === null || _unref$find3 === void 0 ? void 0 : _unref$find3.url.placeholder
          }, null, 8, ["modelValue", "placeholder"])])])) : _createCommentVNode("", true)])])];
        }),
        _: 1
      }, 8, ["modelValue", "before-close"]);
    };
  }
});